<template>
    <v-app>
        <v-main>
            <v-container class="fill-height text-center px-12" fluid>
                <v-row justify="center" class="ma-8">
                    <v-img
                        src="./assets/logo.png"
                        max-height="170"
                        contain
                        ></v-img>
                </v-row>
                <v-row justify="center">
                    <p>Restore &amp; Renew responds to the need for ecological restoration practitioners to incorporate the latest
                    science into their toolkit, helping them to restore diverse, resilient and adaptable ecosystems.</p>
                    <p style="color:blue;">Requires a recent version of Edge, Chrome, Firefox or Safari browsers.</p>
                </v-row>
                <v-row justify="center" class="ma-8">
                    <v-col align-self="center">
                        <v-card
                            height="300px"
                            width="300px"
                            elevation="8"
                            href="/webtool"
                            >
                            <v-img
                                src="./assets/Bush-regen-300px.jpg"
                                class="white--text"
                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                height="300px"
                                width="300px"
                                >
                                <v-card-title class="mb-2 font-weight-bold">R&amp;R Webtool</v-card-title>
                                <v-card-subtitle class="white--text font-weight-bold">Decision-support tool for genetically-informed species restoration</v-card-subtitle>
                            </v-img>
                        </v-card>
                    </v-col>
                    <v-col align-self="center">
                        <v-card
                            height="300px"
                            width="300px"
                            elevation="8"
                            hover
                            href="/sitematch"
                            >
                            <v-img
                                src="./assets/Site_matching_300px.png"
                                class="white--text"
                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                height="300px"
                                width="300px"
                                >
                                <v-card-title class="mb-2 font-weight-bold">R&amp;R Site Matching Tool</v-card-title>
                                <v-card-subtitle class="white--text font-weight-bold">Environmental matching of restoration sites to potential collecting areas including climate change impacts</v-card-subtitle>
                            </v-img>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <p>More information about the Restore &amp; Renew project is available <a href="https://recer.org.au/2022/11/restore_and_renew_restoration_genomics">here</a>, or email us at <a target="_blank" href="mailto:Restore.Renew@rbgsyd.nsw.gov.au">Restore.Renew@rbgsyd.nsw.gov.au</a></p>
                </v-row>
                <v-row justify="center" align="center">
                    <p>Thanks to The NSW Environmental Trust, HSBC and DArT for their support of this project:</p>
                    <a target="_blank" href="https://www.environment.nsw.gov.au/funding-and-support/grants"><img src="./assets/Trust-waratah-colour-small.png" class="welcome-sponsor-logos" /></a>
                    <a target="_blank" href="https://www.about.hsbc.com.au/"><img src="./assets/HSBC-small-logo-no-tagline_C.jpg" class="welcome-sponsor-logos" /></a>
                    <a target="_blank" href="https://www.diversityarrays.com"><img src="./assets/DART_logo.jpg" class="welcome-sponsor-logos" /></a>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>

export default {
    name: 'App',

    components: {
    },

    data: () => ({
        //
    }),
};
</script>
<style>
.col.align-self-center {
    flex-grow: 0;
}
.welcome-sponsor-logos {
    margin: 20px;
}
.v-card__title {
    display: block !important;
}
</style>
